import { BaseSdk } from '../../base.sdk';

export class UserContactsSdk extends BaseSdk {
    async assignToGroup(userContactId: string | string[], groupId: string): Promise<void> {
        if (Array.isArray(userContactId) && userContactId.length > 1) {
            return await this.patch(`${this.userContactsPath}/batch/group`, { contactIds: userContactId, groupId });
        } else {
            let singleUserContactId = userContactId;
            if (Array.isArray(userContactId)) {
                singleUserContactId = userContactId[0];
            }
            return await this.patch(`${this.userContactsPath}/${singleUserContactId}/group`, { groupId });
        }
    }

    async deleteMany(ids: string[]): Promise<void> {
        return await this.delete(`${this.userContactsPath}/batch?ids=[${ids.map((id) => `"${id}"`).join(',')}]`);
    }
}
